var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionAddInpatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#EFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 11.6665H14.9999C14.5579 11.6665 14.134 11.8421 13.8214 12.1547C13.5088 12.4672 13.3333 12.8911 13.3333 13.3332V26.6665C13.3333 27.1085 13.5088 27.5325 13.8214 27.845C14.134 28.1576 14.5579 28.3332 14.9999 28.3332H24.9999C25.4419 28.3332 25.8659 28.1576 26.1784 27.845C26.491 27.5325 26.6666 27.1085 26.6666 26.6665V15.8332L22.4999 11.6665Z",
    stroke: "#175CD3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 11.6665V14.9998C21.6667 15.4419 21.8423 15.8658 22.1549 16.1783C22.4675 16.4909 22.8914 16.6665 23.3334 16.6665H26.6667",
    stroke: "#175CD3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 17.5H16.6667",
    stroke: "#175CD3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 20.8335H16.6667",
    stroke: "#175CD3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 24.1665H16.6667",
    stroke: "#175CD3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionAddInpatient);
export default __webpack_public_path__ + "static/media/action-add-inpatient.4ceee4b4b277997443be155b7f200e2f.svg";
export { ForwardRef as ReactComponent };